<template>
  <div>
    <h3>{{ campaign.name }}</h3>
    <div class="ui-text-italic">
      Created on {{ campaign.dateCreated | timestamp(true) }}
    </div>
    <div class="ui-text-italic">
      Total:
      <b>{{ campaign.counts.total }}</b> Delivered:
      <b>{{ campaign.counts.delivered }}</b> ({{ deliverRate }}) Opened:
      <b>{{ campaign.counts.open }}</b> ({{ openRate }}) Clicked
      <b>{{ campaign.counts.click }}</b> ({{ clickRate }})
    </div>
  </div>
</template>

<script>
// import { db } from "@/db";

export default {
  name: "EdmCampaignSummary",
  props: {
    campaign: {
      type: Object
    }
  },
  data() {
    return {
      // campaign: null
    };
  },
  // firestore: {
  //   campaign: db.collection("emails/data/campaigns").doc(this.id)
  // },
  computed: {
    deliverRate() {
      if (!this.campaign) return null;
      const total = this.campaign.counts.total;
      const delivered = this.campaign.counts.delivered;
      return Math.floor((delivered / total) * 100) + "%";
    },
    openRate() {
      if (!this.campaign) return null;
      const delivered = this.campaign.counts.delivered;
      const open = this.campaign.counts.open;
      return Math.floor((open / delivered) * 100) + "%";
    },
    clickRate() {
      if (!this.campaign) return null;
      const delivered = this.campaign.counts.delivered;
      const click = this.campaign.counts.click;
      return Math.floor((click / delivered) * 100) + "%";
    }
  }
};
</script>

<style scoped></style>
